// const appBaseUrl = "http://api.test.skcoding.com/app";
// const appBaseUrl = "http://192.168.130.218:8106/app";
const appBaseUrl = "https://api.skcoding.com/app";
// const hydraBaseUrl = "http://skoj.test.skcoding.com";
const hydraBaseUrl = "http://skoj.skcoding.com";

export default {
  appBaseUrl,
  hydraBaseUrl,
  uploadUploadAvatar: appBaseUrl + "/sCenter/student/uploadAvatar",
  uploadFileNew: appBaseUrl + "/sCenter/upload",
};
